import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import { Toaster } from 'sonner';
import SmoothScroll from '@/lib/lenis';
import Layout from '@/components/site/Layout';
import Home from '@/pages/Home';
import Calculator from '@/pages/Calculator';
import KnowYourRights from '@/pages/KnowYourRights';
import CaseStudies from '@/pages/CaseStudies';
import FAQ from '@/pages/FAQ';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import { Privacy, Terms, Disclaimer } from '@/pages/Legal';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/calculator" element={<Calculator />} />
              <Route path="/know-your-rights" element={<KnowYourRights />} />
              <Route path="/case-studies" element={<CaseStudies />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </Layout>
        </SmoothScroll>
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: { background: '#121212', border: '1px solid rgba(255,255,255,0.08)', color: '#fff' },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
